import { dscvrIcApi } from '@/shared/api';

export const useReadNotificationMutation = (notifications: bigint[]) => {
  return dscvrIcApi.notification.setReadNotifications(notifications);
};
